var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.53033 12.4697C4.23744 12.1768 3.76256 12.1768 3.46967 12.4697C3.17678 12.7626 3.17678 13.2374 3.46967 13.5303L4.53033 12.4697ZM8.46967 18.5303C8.76256 18.8232 9.23744 18.8232 9.53033 18.5303C9.82322 18.2374 9.82322 17.7626 9.53033 17.4697L8.46967 18.5303ZM3.46967 13.5303L8.46967 18.5303L9.53033 17.4697L4.53033 12.4697L3.46967 13.5303Z",
    fill: "#232C34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5244 7.53021C20.8172 7.23724 20.8171 6.76237 20.5241 6.46955C20.2312 6.17674 19.7563 6.17687 19.4635 6.46985L20.5244 7.53021ZM8.4695 17.4699C8.17669 17.7628 8.17682 18.2377 8.46979 18.5305C8.76276 18.8233 9.23764 18.8232 9.53045 18.5302L8.4695 17.4699ZM19.4635 6.46985L8.4695 17.4699L9.53045 18.5302L20.5244 7.53021L19.4635 6.46985Z",
    fill: "#232C34"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.71565a61c5f2c5cb2b7a5de25080573d.svg";
export { ForwardRef as ReactComponent };